import { render, staticRenderFns } from "./FooterForm.vue?vue&type=template&id=4123aa13&scoped=true&"
import script from "./FooterForm.vue?vue&type=script&lang=js&"
export * from "./FooterForm.vue?vue&type=script&lang=js&"
import style0 from "./FooterForm.vue?vue&type=style&index=0&id=4123aa13&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4123aa13",
  null
  
)

export default component.exports